var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field-card',{attrs:{"label":_vm.label,"border":_vm.border}},[_c('div',{staticClass:"field-text-area",domProps:{"innerHTML":_vm._s(_vm.sanitizedText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }